import { render } from "./StartSession.vue?vue&type=template&id=2c490309"
import script from "./StartSession.vue?vue&type=script&lang=js"
export * from "./StartSession.vue?vue&type=script&lang=js"

import "./StartSession.vue?vue&type=style&index=0&id=2c490309&lang=css"
script.render = render

export default script